/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringIntegrationUpdateTeamIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationUpdateDefaultCustomerIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const monitoringIntegrationUpdatePriorityPolicyOnePriorityMax = 4;

export const monitoringIntegrationUpdatePriorityPolicyTwoDefaultPriorityMax = 4;

export const monitoringIntegrationUpdateExpectedVersionExclusiveMin = 0;
export const monitoringIntegrationUpdateExpectedVersionMax = 9007199254740991;

export const MonitoringIntegrationUpdate = zod.object({
  name: zod.string(),
  teamId: zod.union([zod.uuid().regex(monitoringIntegrationUpdateTeamIdOneRegExp), zod.null()]),
  defaultCustomerId: zod.union([
    zod.uuid().regex(monitoringIntegrationUpdateDefaultCustomerIdOneRegExp),
    zod.null(),
  ]),
  priorityPolicy: zod.union([
    zod.object({
      mode: zod.literal('fixed'),
      priority: zod.int().min(1).max(monitoringIntegrationUpdatePriorityPolicyOnePriorityMax),
    }),
    zod.object({
      mode: zod.literal('payload'),
      field: zod.string().nullable(),
      defaultPriority: zod
        .int()
        .min(1)
        .max(monitoringIntegrationUpdatePriorityPolicyTwoDefaultPriorityMax),
    }),
  ]),
  expectedVersion: zod
    .int()
    .gt(monitoringIntegrationUpdateExpectedVersionExclusiveMin)
    .max(monitoringIntegrationUpdateExpectedVersionMax),
});

export type MonitoringIntegrationUpdate = zod.input<typeof MonitoringIntegrationUpdate>;
export type MonitoringIntegrationUpdateOutput = zod.output<typeof MonitoringIntegrationUpdate>;
